import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionCommon from '../../../../redux/action/FJActionCommon';
import FJHeadshotHistoryItem from '../view/FJHeadshotHistoryItem';
import FJAppConstant from '../../../../constants/FJAppConstant';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';

const FJHeadshotHistoryItemContainer = ({ item }) => {
    const dispatch = useDispatch();

    // 从 Redux 获取状态
    const selectList = useSelector(state => state.common.selectList);
    const isMultipleMode = useSelector(state => state.common.isMultipleMode);

    // 计算当前项是否被选中
    const isSelected = useMemo(() => {
        return selectList.includes(item.id);
    }, [selectList, item.id]);

    // 计算状态
    const isLoading = useMemo(() => {
        return item.status === 'processing' || !item.status;
    }, [item.status]);

    const isError = useMemo(() => {
        return item.status === 'failed';
    }, [item.status]);

    const handleSelect = useCallback(() => {
        if (!isMultipleMode) {
            dispatch(FJActionCommon.setIsMultipleModeAction(true));
        }
        // 切换选择状态
        if (isSelected) {
            const newSelectList = selectList.filter(id => id !== item.id);
            dispatch(FJActionCommon.setSelectListAction(newSelectList));
            if (newSelectList.length === 0) {
                dispatch(FJActionCommon.setIsMultipleModeAction(false));
            }
        } else {
            dispatch(FJActionCommon.setSelectListAction([...selectList, item.id]));
        }
    }, [dispatch, isSelected, item.id, isMultipleMode, selectList]);

    // 事件处理函数
    const handleClick = useCallback(() => {
        // 如果处于多选模式，则切换选择状态
        if (isMultipleMode) {
            handleSelect();
        } else {
            dispatch(FJActionHeadshotGenerator.setCurrentCollectionAction(item));
        }
    }, [dispatch, handleSelect, isMultipleMode, item]);

    const handleDelete = useCallback(() => {
        // 使用 Common 的删除操作
        dispatch(
            FJActionCommon.multiDeleteAction(
                [item.id],
                () => {
                    dispatch(FJActionCommon.setIsMultipleModeAction(false));
                },
                { type: FJAppConstant.HEADSHOT_GENERATOR },
            ),
        );
    }, [dispatch, item.id]);

    const handleDownload = useCallback(() => {
        dispatch(
            FJActionHeadshotGenerator.onDownloadCollectionAction([item.id], () => {
                dispatch(FJActionCommon.setIsMultipleModeAction(false));
            }),
        );
    }, [dispatch, item.id]);

    return (
        <FJHeadshotHistoryItem
            item={item}
            onClick={handleClick}
            onDelete={handleDelete}
            onDownload={handleDownload}
            isSelected={isSelected}
            onSelect={handleSelect}
            isLoading={isLoading}
            isError={isError}
            isMultipleMode={isMultipleMode}
        />
    );
};

FJHeadshotHistoryItemContainer.propTypes = {
    item: PropTypes.object,
};

export default FJHeadshotHistoryItemContainer;
